<div class="dashboard-container">
  <app-page-header title="Dashboard - Secretaria Geral"></app-page-header>

  <div *ngIf="loading" class="loading-container"><mat-spinner diameter="48"></mat-spinner></div>

  <mat-tab-group *ngIf="!loading && dashboard" [(selectedIndex)]="selectedTab" (selectedIndexChange)="onTabChange($event)" animationDuration="200ms">

    <!-- ABA CONCURSOS -->
    <mat-tab label="Concursos">
      <div class="dashboard-grid">
        <app-chart-expandable-card
          title="Concursos Ativos por Andamento"
          [tooltip]="infoTooltips.andamento"
          [chartData]="chartAndamento"
          [chartOptions]="horizontalBarOptions"
          chartType="bar"
          [dynamicHeight]="andamentoHeight"
          scrollDirection="vertical">
        </app-chart-expandable-card>

        <app-chart-expandable-card *ngIf="!isVisaoRestrita"
          title="Concursos por Unidade"
          [tooltip]="infoTooltips.unidade"
          [chartData]="chartConcursosPorUnidade"
          [chartOptions]="barOptions"
          chartType="bar"
          [dynamicWidth]="concursosPorUnidadeWidth"
          scrollDirection="horizontal">
        </app-chart-expandable-card>

        <mat-card class="chart-card" *ngIf="isVisaoRestrita">
          <mat-card-header><mat-card-title>Concursos por Fase</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.fase">info_outline</mat-icon></mat-card-header>
          <mat-card-content><div class="chart-wrapper"><canvas baseChart [data]="chartConcursosPorFase" [options]="barOptions" type="bar"></canvas></div></mat-card-content>
        </mat-card>

        <mat-card class="chart-card">
          <mat-card-header><mat-card-title>Concursos por Tipo</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.tipo">info_outline</mat-icon></mat-card-header>
          <mat-card-content><div class="chart-wrapper"><canvas baseChart [data]="chartConcursosPorTipo" [options]="pieOptions" type="pie"></canvas></div></mat-card-content>
        </mat-card>

        <app-chart-expandable-card *ngIf="!isVisaoRestrita"
          title="Concursos Encerrados por Unidade"
          [tooltip]="infoTooltips.encerrados"
          [chartData]="chartEncerradosPorUnidade"
          [chartOptions]="barOptions"
          chartType="bar"
          [dynamicWidth]="encerradosPorUnidadeWidth"
          scrollDirection="horizontal">
        </app-chart-expandable-card>

        <mat-card class="chart-card chart-card-wide table-card">
          <mat-card-header><mat-card-title>Concursos com Inscrições Abertas ({{ dashboard.concursosInscricoesAbertas.length || 0 }})</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.inscricoesAbertas">info_outline</mat-icon></mat-card-header>
          <mat-card-content>
            <div class="table-scroll-wrapper">
              <table mat-table [dataSource]="dashboard.concursosInscricoesAbertas" class="full-width" *ngIf="(dashboard.concursosInscricoesAbertas.length ?? 0) > 0">
                <ng-container matColumnDef="alerta"><th mat-header-cell *matHeaderCellDef></th><td mat-cell *matCellDef="let c"><mat-icon *ngIf="c.encerrando7Dias" class="alerta-icon" [matTooltip]="'Inscrições encerram em ' + c.diasRestantes + ' dia(s)'">warning</mat-icon></td></ng-container>
                <ng-container matColumnDef="processo"><th mat-header-cell *matHeaderCellDef>Processo</th><td mat-cell *matCellDef="let c">{{ c.processo }}</td></ng-container>
                <ng-container matColumnDef="campus"><th mat-header-cell *matHeaderCellDef>Unidade</th><td mat-cell *matCellDef="let c">{{ c.siglaUnidade || c.campus }}</td></ng-container>
                <ng-container matColumnDef="inicio"><th mat-header-cell *matHeaderCellDef>Início</th><td mat-cell *matCellDef="let c">{{ c.inicio | date:'dd/MM/yyyy' }}</td></ng-container>
                <ng-container matColumnDef="fim"><th mat-header-cell *matHeaderCellDef>Fim</th><td mat-cell *matCellDef="let c">{{ c.fim | date:'dd/MM/yyyy' }}</td></ng-container>
                <ng-container matColumnDef="diasRestantes"><th mat-header-cell *matHeaderCellDef>Prazo</th><td mat-cell *matCellDef="let c"><span [class.alerta]="c.diasRestantes <= 3">{{ c.diasRestantes }}d</span></td></ng-container>
                <ng-container matColumnDef="inscritos"><th mat-header-cell *matHeaderCellDef>Inscritos</th><td mat-cell *matCellDef="let c"><span [class.zero-inscritos]="c.quantidadeInscritos === 0">{{ c.quantidadeInscritos }}</span></td></ng-container>
                <tr mat-header-row *matHeaderRowDef="['alerta','processo','campus','inicio','fim','diasRestantes','inscritos']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['alerta','processo','campus','inicio','fim','diasRestantes','inscritos']" [class.row-alerta]="row.encerrando7Dias"></tr>
              </table>
            </div>
            <p *ngIf="dashboard.concursosInscricoesAbertas.length === 0" class="no-data">Nenhum concurso com inscrições abertas.</p>
          </mat-card-content>
        </mat-card>

        <app-chart-expandable-card
          *ngIf="isVisaoRestrita && (dashboard.recursosPorConcurso?.length ?? 0) > 0"
          title="Recursos por Concurso"
          [tooltip]="infoTooltips.recursos"
          [chartData]="chartRecursos"
          [chartOptions]="recursosOptions"
          chartType="bar"
          [dynamicHeight]="recursosHeight"
          scrollDirection="vertical">
        </app-chart-expandable-card>
      </div>
    </mat-tab>

    <!-- ABA INSCRIÇÕES -->
    <mat-tab label="Inscrições">
      <div class="filtro-aba">
        <mat-form-field appearance="outline" class="filtro-aba-range">
          <mat-label>Filtrar por período de inscrição</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="periodoInicio" placeholder="Início">
            <input matEndDate [(ngModel)]="periodoFim" placeholder="Fim" (dateChange)="onDateRangeChange()">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <button mat-icon-button *ngIf="periodoInicio || periodoFim" (click)="limparPeriodo()" matTooltip="Limpar filtro">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
      <div class="dashboard-grid">
        <app-chart-expandable-card *ngIf="!isVisaoRestrita"
          title="Inscrições por Unidade"
          [tooltip]="infoTooltips.inscricoesUnidade"
          [chartData]="chartInscricoesPorUnidade"
          [chartOptions]="barOptions"
          chartType="bar"
          [dynamicWidth]="inscricoesPorUnidadeWidth"
          scrollDirection="horizontal">
        </app-chart-expandable-card>

        <mat-card class="chart-card">
          <mat-card-header><mat-card-title>Inscrições no Período</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.inscricoesPeriodo">info_outline</mat-icon></mat-card-header>
          <mat-card-content>
            <div class="stat-highlight"><span class="stat-number">{{ dashboard.totalInscricoesPeriodo ?? 0 }}</span><span class="stat-label">Total de inscrições</span></div>
            <div class="chart-wrapper chart-wrapper-sm"><canvas baseChart [data]="chartInscricoesPorStatus" [options]="doughnutOptions" type="doughnut"></canvas></div>
          </mat-card-content>
        </mat-card>

        <app-chart-expandable-card
          *ngIf="isVisaoRestrita"
          title="Inscrições Não Confirmadas por Concurso"
          [tooltip]="infoTooltips.naoConfirmadas"
          [chartData]="chartNaoConfirmadas"
          [chartOptions]="naoConfirmadasOptions"
          chartType="bar"
          [dynamicHeight]="naoConfirmadasHeight"
          scrollDirection="vertical">
        </app-chart-expandable-card>

        <app-chart-expandable-card *ngIf="!isVisaoRestrita"
          title="Inscrições por Gênero por Unidade"
          [tooltip]="infoTooltips.generoUnidade"
          [chartData]="chartGeneroPorUnidade"
          [chartOptions]="groupedBarOptions"
          chartType="bar"
          [dynamicWidth]="generoPorUnidadeWidth"
          scrollDirection="horizontal">
        </app-chart-expandable-card>

        <mat-card class="chart-card" *ngIf="!isVisaoRestrita">
          <mat-card-header><mat-card-title>Inscrições por Gênero por Tipo de Concurso</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.generoTipo">info_outline</mat-icon></mat-card-header>
          <mat-card-content><div class="chart-wrapper"><canvas baseChart [data]="chartGeneroPorTipo" [options]="groupedBarOptions" type="bar"></canvas></div></mat-card-content>
        </mat-card>

        <mat-card class="chart-card">
          <mat-card-header><mat-card-title>Inscrições por Status de Heteroidentificação</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.heteroidentificacao">info_outline</mat-icon></mat-card-header>
          <mat-card-content><div class="chart-wrapper"><canvas baseChart [data]="chartHeteroidentificacao" [options]="barOptions" type="bar"></canvas></div></mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

    <!-- ABA COMISSÃO JULGADORA -->
    <mat-tab label="Comissão Julgadora">
      <div class="dashboard-grid">
        <mat-card class="chart-card table-card" *ngIf="isVisaoRestrita && (dashboard.concursosComissaoIncompleta.length ?? 0) > 0">
          <mat-card-header><mat-card-title>Concursos sem Comissão Completa ({{ dashboard.concursosComissaoIncompleta.length || 0 }})</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.comissao">info_outline</mat-icon></mat-card-header>
          <mat-card-content>
            <div class="table-wrapper">
              <table mat-table [dataSource]="dashboard.concursosComissaoIncompleta" class="full-width">
                <ng-container matColumnDef="processo"><th mat-header-cell *matHeaderCellDef>Processo</th><td mat-cell *matCellDef="let c">{{ c.processo }}</td></ng-container>
                <ng-container matColumnDef="acao"><th mat-header-cell *matHeaderCellDef></th><td mat-cell *matCellDef="let c"><a mat-icon-button [routerLink]="['/concurso', c.id, 'examinadores']" [queryParams]="{concurso: c.id}" matTooltip="Gerenciar examinadores"><mat-icon>group_add</mat-icon></a></td></ng-container>
                <tr mat-header-row *matHeaderRowDef="['processo', 'acao']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['processo', 'acao']"></tr>
              </table>
            </div>
          </mat-card-content>
        </mat-card>

        <app-chart-expandable-card
          title="Concursos por Membro da Comissão"
          [tooltip]="infoTooltips.membros"
          [chartData]="chartMembros"
          [chartOptions]="membrosBarOptions"
          chartType="bar"
          [dynamicHeight]="membrosHeight"
          scrollDirection="vertical">
        </app-chart-expandable-card>
      </div>
    </mat-tab>

    <!-- ABA PROVAS -->
    <mat-tab label="Provas">
      <div class="dashboard-grid">
        <mat-card class="chart-card">
          <mat-card-header><mat-card-title>Provas por Fase</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.provas">info_outline</mat-icon></mat-card-header>
          <mat-card-content><div class="chart-wrapper"><canvas baseChart [data]="chartProvasPorFase" [options]="barOptions" type="bar"></canvas></div></mat-card-content>
        </mat-card>

        <mat-card class="chart-card chart-card-wide" *ngIf="!isVisaoRestrita">
          <mat-card-header><mat-card-title>Provas por Tipo em Cada Fase</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.provasTipo">info_outline</mat-icon></mat-card-header>
          <mat-card-content><div class="chart-wrapper"><canvas baseChart [data]="chartProvasPorTipoEFase" [options]="groupedBarOptions" type="bar"></canvas></div></mat-card-content>
        </mat-card>

        <mat-card class="chart-card" *ngIf="!isVisaoRestrita">
          <mat-card-header><mat-card-title>Ausências por Tipo de Prova</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.ausencias">info_outline</mat-icon></mat-card-header>
          <mat-card-content><div class="chart-wrapper"><canvas baseChart [data]="chartAusencias" [options]="barOptions" type="bar"></canvas></div></mat-card-content>
        </mat-card>

        <mat-card class="chart-card" *ngIf="!isVisaoRestrita">
          <mat-card-header><mat-card-title>Resultado Atual por Fase</mat-card-title><mat-icon class="info-icon" [matTooltip]="infoTooltips.classificacao">info_outline</mat-icon></mat-card-header>
          <mat-card-content><div class="chart-wrapper"><canvas baseChart [data]="chartClassificacaoPorFase" [options]="groupedBarOptions" type="bar"></canvas></div></mat-card-content>
        </mat-card>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
